import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m20 28.783 6.917 4.184c1.266.766 2.816-.367 2.483-1.8L27.567 23.3l6.116-5.3c1.117-.967.517-2.8-.95-2.917l-8.05-.683-3.15-7.433c-.566-1.35-2.5-1.35-3.066 0l-3.15 7.416-8.05.684c-1.467.116-2.067 1.95-.95 2.916l6.116 5.3L10.6 31.15c-.333 1.433 1.217 2.567 2.483 1.8z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }